import React from 'react';
import { useHistory, useLocation, generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Config from 'theme/config';
import routes from 'constants/routes';
import InfoButton from 'components/InfoButton';
import { BonusIdentifier } from 'constants/appEnums';
import { ReactComponent as ArrowSvg } from 'theme/assets/images/arrow.svg';
import { ReactComponent as CrossSvg } from 'theme/assets/images/cross.svg';
import { ReactComponent as LogoSvg } from 'theme/assets/images/nav-logo.svg';

import './NavBar.scss';

interface INavBarConfig {
  showBackArrowButton: boolean;
  showLogo: boolean;
  showBackCrossButton: boolean;
  showInfoButton: boolean;
  copy: string;
  returnNull: boolean;
}

const NavBar = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const handleButtonClick = () => history?.goBack();

  const configureNavBar = () => {
    let response: INavBarConfig = {
      showBackArrowButton: false,
      showLogo: false,
      showBackCrossButton: false,
      showInfoButton: false,
      copy: '',
      returnNull: true
    };

    if (!Config.settings.bonusEnabled) return response;

    switch (location.pathname) {
      case routes.FIVES.route:
        response.showBackArrowButton = true;
        response.showLogo = true;
        response.showInfoButton = true;
        response.returnNull = false;
        break;

      case generatePath(routes.BONUS_DETAILS.route, { bonusType: BonusIdentifier.NewSigning }):
        response.showBackCrossButton = true;
        response.copy = t(BonusIdentifier.NewSigning);
        response.returnNull = false;
        break;

      case generatePath(routes.BONUS_DETAILS.route, { bonusType: BonusIdentifier.DecisionTime }):
        response.showBackCrossButton = true;
        response.copy = t(BonusIdentifier.DecisionTime);
        response.returnNull = false;
        break;

      case generatePath(routes.DECISION_TIME.route, { bonusType: BonusIdentifier.DecisionTime }):
        response.showBackCrossButton = true;
        response.copy = t(BonusIdentifier.DecisionTime);
        response.returnNull = false;
        break;

      case routes.BONUS.route:
        response.showBackArrowButton = true;
        response.copy = t('bonus');
        response.returnNull = false;
        break;

      default:
        break;
    }

    return response;
  };

  const navBarConfig = configureNavBar();
  if (navBarConfig.returnNull) return null;

  return (
    <div className="nav-bar">
      {navBarConfig.showBackArrowButton && (
        <button className="nav-bar__button nav-bar__arrow-button" onClick={handleButtonClick}>
          <ArrowSvg className="nav-bar__arrow-svg nav-bar__svg" />
        </button>
      )}
      <div className="nav-bar__centre-position">
        {navBarConfig.copy && <div className="nav-bar__copy">{navBarConfig.copy}</div>}
        {navBarConfig.showLogo && <LogoSvg className="nav-bar__svg nav-bar__logo-svg" height={30} />}
      </div>
      {navBarConfig.showBackCrossButton && (
        <button className="nav-bar__button nav-bar__cross-button" onClick={handleButtonClick}>
          <CrossSvg className="nav-bar__svg" />
        </button>
      )}
      {navBarConfig.showInfoButton && <InfoButton />}
    </div>
  );
};

export default NavBar;
